import { createUseStyles } from 'react-jss';
import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    groupWrapper: {
        paddingBottom: theme.spacing(5),
        paddingTop: theme.spacing(5),
        [theme.down('tablet')]: {
            paddingBottom: theme.spacing(3),
            paddingTop: theme.spacing(3),
        },
    },
    groupHeader: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        paddingBottom: theme.spacing(4),
    },
    h4: {
        fontFamily: theme.font.secondary,
        fontSize: 20,
        lineHeight: 1.4,
        fontWeight: 'normal',
        color: theme.colors.black,
        overflowWrap: 'anywhere',
    },
    text: {
        color: theme.colors.black,
        lineHeight: 1.5,
        fontSize: 16,
        fontFamily: theme.font.primary,
        [theme.down('tablet')]: {
            fontSize: 14,
        },
    },
    descriptionText: {
        fontFamily: theme.font.primary,
        fontSize: 14,
        lineHeight: 1.5,
        color: theme.colors.grey_text,
        margin: `${theme.spacing(0.5)}px 0 0`,
        overflowWrap: 'anywhere',
    },
    cardList: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        alignItems: 'start',
        gap: theme.spacing(3),
        [theme.down('desktop')]: {
            gridTemplateColumns: 'repeat(2, 1fr)',
        },
        [theme.down('mobile')]: {
            gridTemplateColumns: '1fr',
        },
    },
}));
